<template>
  <!-- 审批管理主页面 -->
  <div class="team">
    <!-- 使用Element UI的标签页组件 -->
    <el-tabs v-model="tabsActiveName" type="border-card" @tab-click="tabClick">
      <!-- 我的审批标签页 -->
      <el-tab-pane :label="$t('approval.myApproval')" name="approval">
        <div>
          <!-- 标题和筛选区域 -->
          <div class="title-class base-flex__between">
            <div class="titleCls pad_bot_cls">{{ $t('approval.myApproval') }}</div>
            <div class="base-margin__right-10">
              <!-- 审批状态筛选下拉框 -->
              <el-select
                v-model="applySelectValue"
                :placeholder="$t('approval.selectFilterType')"
                class="base-width__240"
                @change="changeApplyValue"
              >
                <el-option
                  v-for="item in applySelectList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>

          <!-- 审批列表表格 -->
          <div class="base-background__white pad_top_bottom_right——20">
            <div class="table">
              <el-table
                v-loading="tableLoading"
                :data="tableApprovalData"
                border
                header-align="center"
              >
                <!-- 各列定义 -->
                <el-table-column :label="$t('approval.id')" prop="id" width="100"/>
                <el-table-column :label="$t('approval.approvalType')" width="120">
                  <template slot-scope="scope">
                    {{ filterApplyScene(scope.row.scene) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('approval.applicationContent')" prop="content"/>
                <el-table-column :label="$t('approval.applicant')" prop="applyUser.name" width="120"/>
                <el-table-column :label="$t('approval.applicationTime')" prop="createTime" width="200"/>
                <el-table-column :label="$t('approval.currentStatus')" prop="status" width="120">
                  <template slot-scope="scope">
                    {{ filterApplyStatus(scope.row.status) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('approval.operation')" width="140">
                  <template slot-scope="scope">
                    <div>
                      <!-- 待审批状态显示操作按钮 -->
                      <span v-if="scope.row.status === 1">
                        <el-button type="text" @click="projectApplyApprove('pass', scope.row)">
                          {{ $t('approval.approve') }}
                        </el-button>
                        <el-button type="text" @click="projectApplyApprove('reject', scope.row)">
                          {{ $t('approval.reject') }}
                        </el-button>
                      </span>
                      <!-- 特定场景下的取消审批按钮 -->
                      <el-button
                        v-if="scope.row.scene === 2 && scope.row.status === 3"
                        type="text"
                        @click="projectApplyApprove('expired', scope.row)"
                      >
                        {{ $t('approval.cancelApproval') }}
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 分页组件 -->
              <el-pagination
                :page-size.sync="pageSize"
                :page-sizes="[10, 20, 50, 100]"
                :total="tableApprovalTotal"
                align="right"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeApprovalChange"
                @current-change="onCurrentApprovalChange"
              />
            </div>
          </div>
        </div>
      </el-tab-pane>

      <!-- 我的申请标签页 -->
      <el-tab-pane :label="$t('approval.myApplication')" name="apply">
        <div>
          <!-- 标题和筛选区域 -->
          <div class="title-class base-flex__between">
            <div class="titleCls pad_bot_cls">{{ $t('approval.myApplication') }}</div>
            <div class="base-margin__right-10">
              <!-- 申请状态筛选下拉框 -->
              <el-select
                v-model="applySelectValue"
                :placeholder="$t('approval.selectFilterType')"
                class="base-width__240"
                @change="changeApplyValue"
              >
                <el-option
                  v-for="item in applySelectList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                />
              </el-select>
            </div>
          </div>

          <!-- 申请列表表格 -->
          <div class="base-background__white pad_top_bottom_right——20">
            <div class="table">
              <el-table :data="tableApplyData" border header-align="center">
                <!-- 各列定义 -->
                <el-table-column :label="$t('approval.id')" prop="id" width="100"/>
                <el-table-column :label="$t('approval.approvalType')" width="120">
                  <template slot-scope="scope">
                    {{ filterApplyScene(scope.row.scene) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('approval.applicationContent')" prop="content"/>
                <el-table-column :label="$t('approval.applicant')" prop="applyUser.name" width="120"/>
                <el-table-column :label="$t('approval.applicationTime')" prop="createTime" width="200"/>
                <el-table-column :label="$t('approval.currentStatus')" prop="status" width="200">
                  <template slot-scope="scope">
                    {{ filterApplyStatus(scope.row.status) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('approval.approvalTime')" width="200">
                  <template slot-scope="scope">
                    {{ filterUpdateTime(scope.row) }}
                  </template>
                </el-table-column>
                <el-table-column :label="$t('approval.operation')" width="140">
                  <template slot-scope="scope">
                    <div>
                      <!-- 撤销申请按钮 -->
                      <el-button
                        :disabled="scope.row.status !== 1"
                        type="text"
                        @click="projectApplyModify('cancel', scope.row)"
                      >
                        {{ $t('approval.cancel') }}
                      </el-button>
                      <!-- 下载按钮 -->
                      <el-button
                        v-if="scope.row.status === 3"
                        type="text"
                        @click="openDownload(scope.row.id)"
                      >
                        {{ $t('approval.download') }}
                      </el-button>
                    </div>
                  </template>
                </el-table-column>
              </el-table>

              <!-- 分页组件 -->
              <el-pagination
                :page-size.sync="pageSize"
                :page-sizes="[10, 20, 50, 100]"
                :total="tableApplyTotal"
                align="right"
                layout="total, sizes, prev, pager, next, jumper"
                @size-change="handleSizeApplyChange"
                @current-change="onCurrentApplyChange"
              />
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>

    <!-- 下载文件组件 -->
    <downloadFile ref="downloadFileRef"/>
  </div>
</template>

<script>
// 导入必要的模块和组件
import {mapGetters, mapState} from 'vuex';
import {postRequest} from '@/common/libs/request';
import {APPLY_ACCEPT} from '@/common/constants';
import {applyStatusList, filterApplyScene, filterApplyStatus} from '@/common/utils/utils';
import DownloadFile from './components/downloadFile/index.vue';

export default {
  name: 'IndexView',
  components: {
    // 注册下载文件组件
    DownloadFile
  },
  data() {
    return {
      // 表格数据
      tableApplyData: [],    // 申请列表数据
      tableApprovalData: [], // 审批列表数据

      // 项目信息
      projectId: 0,          // 当前项目ID
      isOwner: 0,            // 是否是项目所有者
      projectName: '',       // 项目名称

      // 状态和配置
      applyAccept: APPLY_ACCEPT, // 申请接受状态
      dialogVisible: false,      // 对话框显示状态
      descriptionContent: this.$t('approval.invitationContent'), // 邀请内容
      loginType: window.sessionStorage.getItem('loginType'),    // 登录类型

      // 标签页和分页相关
      tabsActiveName: 'approval', // 当前激活的标签页
      tableApprovalTotal: 0,      // 审批列表总数
      tableApplyTotal: 0,         // 申请列表总数
      applyPageIndex: 1,          // 申请列表当前页码
      applyPageLimit: 10,         // 申请列表每页条数
      approvalPageIndex: 1,       // 审批列表当前页码
      approvalPageLimit: 10,      // 审批列表每页条数
      pageSize: 10,              // 分页大小

      // 筛选相关
      filterApplyStatus,          // 状态过滤方法
      filterApplyScene,           // 场景过滤方法
      applySelectValue: 0,        // 筛选选中的值
      applySelectList: applyStatusList, // 筛选选项列表

      // 其他
      cosFileList: [],     // COS文件列表
      tableLoading: false, // 表格加载状态
    };
  },
  computed: {
    // 从Vuex获取应用状态
    ...mapState(['app']),
    // 从Vuex获取当前项目信息
    ...mapGetters('app', ['getCurrentProject']),

    // 用户信息计算属性
    userInfo() {
      return this.app.userInfo;
    },
  },
  watch: {
    /**
     * 监听项目信息变化
     * @param val 变化后的项目信息
     */
    'app.currentProject'(val) {
      const currentProject = this.getCurrentProject();
      this.isOwner = val.isOwner;
      if (currentProject.id !== this.projectId) {
        // 初始化项目信息
        const currentProject = this.getCurrentProject() || {};
        this.isOwner = currentProject.isOwner;
        this.projectId = currentProject.id;
        this.projectName = currentProject.name;
        // 默认加载审批列表
        this.tabClick({name: 'approval'});
      }
    },
  },
  filters: {
    // 角色过滤器
    roleFilter(val) {
      switch (val) {
        case 'owner':
          return this.$t('approval.role.admin');
        case 'member':
          return this.$t('approval.role.member');
        default:
          return this.$t('approval.role.apply');
      }
    },
  },
  methods: {
    /**
     * 过滤更新时间显示
     * @param {Object} item - 行数据
     * @returns {string} 更新时间或占位符
     */
    filterUpdateTime(item) {
      let updateTime = '_';
      if (item.status !== 1 && item.status !== 4 && item.status !== 5) {
        updateTime = item.updateTime;
      }
      return updateTime;
    },

    /**
     * 打开下载对话框
     * @param {number} applyId - 申请ID
     */
    openDownload(applyId) {
      const data = {applyId};
      this.$refs.downloadFileRef.openDownload(data);
    },

    /**
     * 筛选值变化处理
     */
    async changeApplyValue() {
      if (this.tabsActiveName === 'apply') {
        await this.getProjectApplyList();
      } else {
        await this.getProjectApprovalList();
      }
    },

    /**
     * 标签页切换处理
     * @param {Object} item - 标签页对象
     */
    async tabClick(item) {
      // 重置筛选和分页参数
      this.applySelectValue = 0;
      this.applyPageIndex = 1;
      this.applyPageLimit = 10;
      this.tableApplyTotal = 0;
      this.approvalPageIndex = 1;
      this.approvalPageLimit = 10;
      this.tableApprovalTotal = 0;
      this.pageSize = 10;

      // 根据标签页加载对应数据
      if (item.name === 'apply') {
        await this.getProjectApplyList();
      } else {
        await this.getProjectApprovalList();
      }
    },

    /**
     * 审批操作
     * @param {string} action - 操作类型(pass/reject/expired)
     * @param {Object} row - 行数据
     */
    projectApplyApprove(action, row) {
      this.tableLoading = true;
      postRequest('/api/eda/common/project/projectApplyApprove', {
        applyId: row.id,
        action,
      }).then(() => {
        this.$message.success(this.$t('approval.operationComplete'));
        this.tableLoading = false;
        this.getProjectApprovalList();
      }).catch(() => {
        this.tableLoading = false;
      });
    },

    /**
     * 申请修改操作
     * @param {string} action - 操作类型
     * @param {Object} row - 行数据
     */
    projectApplyModify(action, row) {
      postRequest('/api/eda/common/project/projectApplyModify', {
        applyId: row.id,
        action,
      }).then(() => {
        this.$message.success(this.$t('approval.withdrawSuccess'));
        this.getProjectApplyList();
      });
    },

    /**
     * 审批操作(带验证)
     * @param {string} action - 操作类型(pass/reject)
     * @param {number} idx - 行索引
     * @param {Object} row - 行数据
     */
    async onApprove(action, idx, row) {
      try {
        // 验证操作类型
        if (action !== 'pass' && action !== 'reject') {
          this.$message(this.$t('approval.invalidApprovalParam'));
          return false;
        }

        // 发送审批请求
        const res = await postRequest('/api/eda/common/project/projectApplyApprove', {
          applyId: row.id,
          action,
        });

        // 处理审批结果
        if (res) {
          this.$message.success(this.$t('approval.approvalSuccess'));
          await this.getProjectApprovalList();
        }
      } catch (e) {
        this.$message(this.$t('approval.approvalFailed'));
      }
    },

    /**
     * 获取审批列表
     */
    async getProjectApprovalList() {
      const offset = this.approvalPageLimit * (this.approvalPageIndex - 1);
      postRequest('/api/eda/common/project/getProjectApprovalList', {
        scene: 0,
        offset,
        status: this.applySelectValue,
        limit: this.approvalPageLimit,
      }).then((res) => {
        this.tableApprovalData = res?.list || [];
        this.tableApprovalTotal = res?.total || 0;
      }).catch(() => {
        this.$message(this.$t('approval.approvalListFailed'));
      });
    },

    /**
     * 获取申请列表
     */
    async getProjectApplyList() {
      const offset = this.applyPageLimit * (this.applyPageIndex - 1);
      postRequest('/api/eda/common/project/getProjectApplyList', {
        scene: 0,
        offset,
        status: this.applySelectValue,
        limit: this.applyPageLimit,
      }).then((res) => {
        this.tableApplyData = res?.list || [];
        this.tableApplyTotal = res?.total || 0;
      }).catch(() => {
        this.$message(this.$t('approval.applicationListFailed'));
      });
    },

    /**
     * 审批列表每页条数变化处理
     * @param {number} val - 每页条数
     */
    handleSizeApprovalChange(val) {
      this.approvalPageLimit = val;
      this.getProjectApprovalList();
    },

    /**
     * 审批列表页码变化处理
     * @param {number} val - 当前页码
     */
    onCurrentApprovalChange(val) {
      this.approvalPageIndex = val;
      this.getProjectApprovalList();
    },

    /**
     * 申请列表页码变化处理
     * @param {number} val - 当前页码
     */
    onCurrentApplyChange(val) {
      this.applyPageIndex = val;
      this.getProjectApplyList();
    },

    /**
     * 申请列表每页条数变化处理
     * @param {number} val - 每页条数
     */
    handleSizeApplyChange(val) {
      this.applyPageLimit = val;
      this.getProjectApplyList();
    },
  },

  // 组件挂载后执行
  mounted() {
    // 初始化项目信息
    const currentProject = this.getCurrentProject() || {};
    this.isOwner = currentProject.isOwner;
    this.projectId = currentProject.id;
    this.projectName = currentProject.name;

    // 默认加载审批列表
    this.tabClick({name: 'approval'});
  },
};
</script>


<style lang="scss" scoped>
// 团队管理整体样式
.team {
  text-align: left;
  //background: #eee;

  .title-class {
    padding: 10px;
    background: #fff;
  }
}

// table 背景颜色+padding10px
.table {
  background: #fff;
  padding: 0;
  // table内容部分下边距和最小高度
  .el-table {
    margin-bottom: 10px;
    min-height: 264px;
  }
}

.titleCls {
  font-size: 14px;
  font-weight: 600;
  margin-left: 10px;
  padding-top: 10px;
}

.el-table {
  &:deep(.el-table__cell) {
    text-align: center;
  }
}

.pad_bot_cls {
  margin-right: 18px;
}

.pad_top_bottom_right——20 {
  padding: 0 20px 20px;
}
</style>
